import { Component, Input, OnInit } from '@angular/core';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-file-assets-section',
  templateUrl: './file-assets-section.component.html',
  styleUrls: ['./file-assets-section.component.scss']
})
export class FileAssetsSectionComponent implements OnInit {
  @Input() sections: Section[] = [];
  constructor() {}

  ngOnInit(): void {}
}
